// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";

const AdminAccountAddApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/account_add";

    // API実行, name, email, password, auth
    const ExecAdminAccountAddApi = async (name, email, password, auth) => {

        // 必要なリクエストを定義
        const requestParams = {
            name: name,
            email: email,
            password: password,
            auth: auth,
        };

        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url:url, requestParams:requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminAccountAddApi;
};

export default AdminAccountAddApi;
